import * as Yup from 'yup'
import { Trans } from '../../../../components'
import { Form, Formik } from 'formik'
import { INDIRIZZI, NAZIONI, PROVINCE } from '../../../../utils/endpoint'
import { api } from '../../../../utils'
import { connect } from 'react-redux'
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import FormField from '../../../atoms/FormField/FormField'
import FormInput from '../../../atoms/FormInput/FormInput'
import FormSelect from '../../../atoms/FormSelect/FormSelect'
import FormCheckbox from '../../../atoms/FormCheckbox/FormCheckbox'
import Button from '../../../atoms/Button/Button'
import useTrans from '../../../../hooks/useTrans'
import LoadingSvg from '../../../atoms/Loading/Loading'
api.defaults.xsrfCookieName = 'csrftoken'
api.defaults.xsrfHeaderName = 'X-CSRFTOKEN'

const schema = (t) =>
  Yup.object({
    ragione_sociale: Yup.string()
      .min(2, t('Troppo corto'))
      .max(50, t('Troppo lungo'))
      .required(t('Obbligatorio')),
    indirizzo: Yup.string()
      .min(2, t('Troppo corto'))
      .max(35, t('Troppo lungo'))
      .required(t('Obbligatorio')),
    cap: Yup.string().required('Obbligatorio'),
    citta: Yup.string()
      .min(1, t('Troppo corto'))
      .max(50, t('Troppo lungo'))
      .required(t('Obbligatorio')),
    provincia: Yup.string()
      .nullable()
      .when('withProvincia', {
        is: true,
        then: Yup.string().required(t('Obbligatorio')).nullable(),
      }),
    telefono: Yup.number()
      .nullable()
      .typeError(t('Non è stato inserito un numero di telefono valido'))
      .positive(t('Valore negativo'))
      .integer(t('Valore intero'))
      .test('len', t('Numero troppo corto'), (val) => !val || (val && val.toString().length >= 6)),
    email: Yup.string(t('Email non valida')).email(t('Email non valida')).nullable(),
    nazione_id: Yup.string().required(t('Obbligatorio')),
  })

const FormIndirizzo = ({
  utente,
  refetchModal,
  setRefetchModal,
  setVisible,
  _refetchModal,
  isModal,
  handleSubmit,
  handleSetNewIndirizzo,
  handleSetEditIndirizzo,
  editIndirizzo,
  i18n,
  onClose,
  setAdded,
}) => {
  const [nazioni, setNazioni] = useState([])
  const [Loading, setLoading] = useState(true)
  const [province, setProvince] = useState([])
  const t = useTrans()
  const getFieldClass = (field, values, errors) => {
    return errors[field] ? 'error' : values[field] !== '' ? 'valid' : ''
  }

  const fetchNazioni = async () => {
    api
      .get(NAZIONI)
      .then((response) => {
        setNazioni(response.data)
        setLoading(false)
      })
      .catch((error) => console.log(error), setLoading(false))

    api
      .get(PROVINCE)
      .then((response) => {
        setProvince(response.data)

        setLoading(false)
      })
      .catch((error) => console.log(error), setLoading(false))
  }

  const handleCloseForm = () => {
    handleSetNewIndirizzo(false)
    handleSetEditIndirizzo(null)
  }

  const handleSaveNewIndirizzo = async (values) => {
    await api
      .post(INDIRIZZI, { ...values })
      .then((response) => {
        isModal ? (_refetchModal(), setVisible(false)) : handleCloseForm()
      })
      .catch(
        (error) => (
          console.log(error), isModal ? (_refetchModal(), setVisible(false)) : handleCloseForm()
        )
      )
    setAdded && setAdded(true)
  }

  const handleSaveEditIndirizzo = async (values) => {
    await api
      .put(INDIRIZZI + editIndirizzo.id + '/', { ...values })
      .then((response) => {
        isModal ? (_refetchModal(), setVisible(false)) : handleCloseForm()
      })
      .catch(
        (error) => (
          console.log(error), isModal ? (_refetchModal(), setVisible(false)) : handleCloseForm()
        )
      )
  }

  useEffect(() => {
    fetchNazioni()
  }, [])

  return Loading ? (
    <LoadingSvg />
  ) : (
    <>
      <Formik
        validateOnMount={isModal && editIndirizzo ? true : false}
        validateOnChange={true}
        initialValues={
          editIndirizzo
            ? {
                withProvincia:
                  editIndirizzo?.provincia && editIndirizzo.nazione.codice === 'IT' ? true : false,
                ragione_sociale: editIndirizzo.ragione_sociale,
                indirizzo: editIndirizzo.indirizzo,
                cap: editIndirizzo.cap,
                citta: editIndirizzo.citta,
                nazione_id: editIndirizzo.nazione_id,
                telefono: editIndirizzo.telefono,
                email: editIndirizzo.email,
                preferenziale: editIndirizzo.preferenziale,
                provincia: editIndirizzo?.provincia,
              }
            : {
                withProvincia: false,
                ragione_sociale: '',
                indirizzo: '',
                cap: '',
                citta: '',
                nazione_id: '',
                telefono: '',
                email: '',
                preferenziale: false,
              }
        }
        validationSchema={schema(t)}
        onSubmit={(values) => {
          editIndirizzo ? handleSaveEditIndirizzo(values) : handleSaveNewIndirizzo(values)
          onClose && onClose(editIndirizzo?.id)
        }}
      >
        {({
          values,
          errors,
          handleChange,
          handleBlur,
          isSubmitting,
          validateForm,
          validateField,
          isValid,
          touched,
          setFieldValue,
          handleSubmit,
        }) => (
          <div className="form__indirizzo">
            <FormField
              label={t('RAGIONE SOCIALE*')}
              status={
                touched.ragione_sociale && errors.ragione_sociale
                  ? 'error'
                  : touched.ragione_sociale && 'success'
              }
              errorMessage={errors?.ragione_sociale}
            >
              <FormInput
                type="text"
                onBlur={handleBlur}
                id="ragione_sociale"
                name="ragione_sociale"
                value={values.ragione_sociale}
                onChange={handleChange}
                placeholder={t('Inserisci ragione sociale')}
              />
            </FormField>

            <FormField
              label={t('INDIRIZZO*')}
              status={
                touched.indirizzo && errors.indirizzo ? 'error' : touched.indirizzo && 'success'
              }
              errorMessage={errors?.indirizzo}
            >
              <FormInput
                type="text"
                id="indirizzo"
                name="indirizzo"
                onBlur={handleBlur}
                value={values.indirizzo}
                onChange={handleChange}
                placeholder={t("Inserisci l'indirizzo")}
              />
            </FormField>

            <div className="row">
              <div className="col-12 col-md-3">
                <FormField
                  label={t('CAP*')}
                  status={touched.cap && errors.cap ? 'error' : touched.cap && 'success'}
                  errorMessage={errors?.cap}
                >
                  <FormInput
                    type="text"
                    id="cap"
                    name="cap"
                    onBlur={handleBlur}
                    value={values.cap}
                    onChange={handleChange}
                    placeholder={t('Inserisci il cap')}
                  />
                </FormField>
              </div>
              <div className={values?.withProvincia ? 'col-12 col-md-3' : 'col-12 col-md-6'}>
                <FormField
                  label={t('CITTÀ*')}
                  status={touched.citta && errors.citta ? 'error' : touched.citta && 'success'}
                  errorMessage={errors?.citta}
                >
                  <FormInput
                    type="text"
                    id="citta"
                    name="citta"
                    onBlur={handleBlur}
                    value={values.citta}
                    onChange={(e) => setFieldValue('citta', e.target.value)}
                    placeholder={t('Inserisci la città')}
                  />{' '}
                </FormField>
              </div>
              <div className="col-12 col-md-3">
                <FormField
                  label={t('Paese*')}
                  status={
                    touched.nazione_id
                      ? errors.nazione_id
                        ? 'error'
                        : touched.nazione_id
                        ? 'success'
                        : null
                      : null
                  }
                  errorMessage={errors?.nazione_id}
                >
                  <FormSelect
                    isSearchable={true}
                    onBlur={() => handleBlur('nazione_id')}
                    onChange={(e) => {
                      setFieldValue('withProvincia', e.label === 'Italia' ? true : false)
                      setFieldValue('nazione_id', e.value)
                      validateForm()
                    }}
                    value={{
                      label: values?.nazione_id
                        ? nazioni.filter((nazione) => nazione.id === values.nazione_id)[0]?.nome
                        : t('Paese*'),
                    }}
                    options={nazioni.map((nazione) => {
                      return {
                        label: nazione.nome,
                        value: nazione.id,
                      }
                    })}
                  ></FormSelect>
                </FormField>
              </div>
              {/* ! Task su aggiunta Provincia nel Caso Nazione fosse Italia  */}

              {values?.withProvincia && (
                <div className="col-12 col-md-3">
                  <FormField
                    label={t('Provincia*')}
                    status={
                      touched.provincia && errors.provincia
                        ? 'error'
                        : touched.provincia && 'success'
                    }
                    errorMessage={errors?.provincia}
                  >
                    <FormSelect
                      isSearchable={true}
                      onChange={(e) => {
                        setFieldValue('provincia', e.value)
                      }}
                      value={{
                        label: values?.provincia
                          ? province.filter((p) => p.sigla === values.provincia)[0]?.nome
                          : t('Provincia*'),
                      }}
                      options={province.map((p) => {
                        return {
                          label: p.nome,
                          value: p.sigla,
                        }
                      })}
                    ></FormSelect>
                  </FormField>
                </div>
              )}
            </div>
            <div className="row">
              <div className="col-12 col-md-6">
                <FormField
                  label={isModal ? t('TELEFONO') : t('TELEFONO*')}
                  status={
                    touched.telefono
                      ? errors.telefono
                        ? 'error'
                        : touched.telefono
                        ? 'success'
                        : null
                      : null
                  }
                  errorMessage={errors?.telefono}
                >
                  <FormInput
                    type="text"
                    onBlur={handleBlur}
                    id="telefono"
                    name="telefono"
                    value={values.telefono}
                    onChange={handleChange}
                    placeholder={t('Inserisci un numero di telefono')}
                  />
                </FormField>
              </div>
              <div className="col-12 col-md-6">
                <FormField
                  label={t('E-MAIL PER AVVISO DELLA SPEDIZIONE')}
                  status={
                    touched.email
                      ? errors.email
                        ? 'error'
                        : touched.email
                        ? 'success'
                        : null
                      : null
                  }
                  errorMessage={errors?.email}
                >
                  <FormInput
                    type="text"
                    id="email"
                    onBlur={handleBlur}
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                    placeholder={t("Inserisci un'e-mail per l'avviso della spedizione")}
                  />
                </FormField>
              </div>
            </div>
            <div className="w-form__field-wrapper form__indirizzo__content__predefinito">
              <FormField>
                <FormCheckbox
                  label={t('Usa come indirizzo predefinito')}
                  id="preferenziale"
                  onBlur={handleBlur}
                  name="preferenziale"
                  value={1}
                  checked={values.preferenziale}
                  onChange={handleChange}
                />
              </FormField>
            </div>
            <p className="form__indirizzo__legend">{t('*Campi obbligatori')}</p>
            <div className="form__indirizzo__content__buttons">
              <Button
                variant="ghost"
                label={t('Annulla')}
                onClick={() => (isModal ? setVisible(false) : handleCloseForm())}
              />
              <Button
                variant="primary"
                onClick={() => handleSubmit()}
                disabled={!isValid || isSubmitting}
                label={
                  isModal
                    ? t('Spedisci a questo indirizzo')
                    : editIndirizzo
                    ? t('Modifica Indirizzo')
                    : t('Aggiungi Indirizzo')
                }
              />
            </div>
          </div>
        )}
      </Formik>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    utente: state.utente.utente,
  }
}

FormIndirizzo.propTypes = {
  utente: PropTypes.object,
  handleSetNewIndirizzo: PropTypes.func,
  handleSetEditIndirizzo: PropTypes.func,
  editIndirizzo: PropTypes.object,
  i18n: PropTypes.object,
  t: PropTypes.func,
}

export default connect(mapStateToProps, null)(FormIndirizzo)
